<template>
  <div class="m-carousel">
    <!-- Slider main container -->
    <div
      class="swiper-container"
      ref="swiperContainer"
    >
      <!-- Additional required wrapper -->
      <div class="swiper-wrapper">
        <!-- Slides -->
        <slot />
      </div>
    </div>

    <!-- If we need navigation buttons -->
    <a
      role="button"
      :aria-label="prevLabel"
      class="swiper-button-prev m-carousel-prev"
    />
    <a
      role="button"
      :aria-label="nextLabel"
      class="swiper-button-next m-carousel-next"
    />
  </div>
</template>

<script>
/* eslint-disable import/no-duplicates */
import Swiper from 'swiper'
import SwiperCore, { Navigation } from 'swiper/core'
import 'swiper/swiper-bundle.css'
SwiperCore.use([Navigation])

export default {
  name: 'Carousel',
  components: {},
  props: {
    slidesPerView: {
      type: [Number, String],
      default: 1
    },
    slidesPerGroup: {
      type: Number,
      default: 1
    },
    spaceBetween: {
      type: Number,
      default: 20
    },
    breakpoints: {
      type: Object,
      default: () => ({
        1216: {
          slidesPerView: 4,
          slidesPerGroup: 4
        },
        769: {
          slidesPerView: 3,
          slidesPerGroup: 3
        },
        480: {
          slidesPerView: 2,
          slidesPerGroup: 2
        }
      }),
      validator (object) {
        return Object.keys(object).every(key => !isNaN(key))
      }
    },
    slideClass: {
      type: String,
      default: 'm-carousel-slide'
    },
    loop: {
      type: Boolean,
      default: false
    },
    prevLabel: {
      type: String,
      default: 'Previous'
    },
    nextLabel: {
      type: String,
      default: 'Next'
    }
  },
  data () {
    return {
      swiper: null
    }
  },
  mounted () {
    this.initSwiper()
  },
  unmounted () {
    this.destroySwiper()
  },
  methods: {
    initSwiper () {
      this.swiper = new Swiper(this.$refs.swiperContainer, {
        navigation: {
          prevEl: '.m-carousel-prev',
          nextEl: '.m-carousel-next'
        },
        slideClass: this.slideClass,
        breakpoints: this.breakpoints,
        slidesPerView: this.slidesPerView,
        slidesPerGroup: this.slidesPerGroup,
        spaceBetween: this.spaceBetween,
        loop: this.loop
      })
    },
    destroySwiper () {
      if (this.swiper) {
        this.swiper.destroy()
        this.swiper = null
      }
    }
  }
}
</script>

<style lang="less">
@import (reference) "./../../less/shared/utilities.less";
@import "@{frontend_static_less}/public/modules/m-carousel.less";

.swiper-container {
  overflow-x: hidden;
  margin: 0 @box-padding/2
}
</style>
